import React from "react";
import { withTranslation } from 'react-i18next';
import { Grid, Select,FormControl } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusSquare, faPlusSquare } from "@fortawesome/free-regular-svg-icons"

//class Room extends React.Component {

class Room extends React.Component {

    constructor (props) {
        super(props)
    }

    render() {
        const { t } = this.props;
        return (
            <div className="pax_box" role="group">
                <label tabIndex={0} style={{width:'100%',display:'flex'}}>
                <Grid item xs={6} className="title mb-3 mt-3">
                    <h4>{t('pax.adults.title')}</h4>
                    <small>{t('pax.adults.ageRange')}</small>
                </Grid>
                <Grid item xs={6} className="mb-3 mt-3" align="center"  role="group" aria-label={t('pax.ariaLabels.adults')}>
                    <Grid container  style={{alignItems:'center', direction: 'ltr'}}>
                        <Grid item xs={5}>
                            <button type="button" className="minus" name="adults" role="button" aria-label={t('pax.adults.remove')} onClick={(e) => this.props.ModifyAdults(-1)} style={{border:'none'}} title={t('pax.adults.remove')}>
                                <FontAwesomeIcon icon={faMinusSquare} /></button>
                        </Grid>
                        <Grid item xs={2} className="caption">
                            <div title={t('pax.adults.selected', { count: this.props?.filters.rooms[0]?.adults.length })} role="spinbutton" aria-live="polite" aria-label={t('pax.adults.selected', { count: this.props?.filters.rooms[0]?.adults.length })}><strong>{this.props?.filters.rooms[0]?.adults.length}</strong></div>
                        </Grid>
                        <Grid item xs>
                            <button type="button" className="plus" onClick={(e) => this.props.ModifyAdults(1)} role="button" aria-label={t('pax.adults.add')} title={t('pax.adults.add')} style={{border:'none'}}>
                                <FontAwesomeIcon icon={faPlusSquare} size="3x" /></button>
                        </Grid>
                    </Grid>
                </Grid>
                </label>

                <label tabIndex={0} style={{width:'100%',display:'flex'}}>
                <Grid item xs={6} className="title mb-3 mt-3" tabIndex={0}>
                    <h4>{t('pax.teens.title')}</h4>
                    <small>{t('pax.teens.ageRange')}</small>
                </Grid>
                <Grid item xs={6} className="mb-3 mt-3" align="center"  role="group" aria-label={t('pax.ariaLabels.teens')}>
                    <Grid container style={{alignItems:'center', direction: 'ltr'}}>
                        <Grid item xs={5}>
                            <button className="minus" name="teens" title={t('pax.teens.remove')} aria-label={t('pax.teens.remove')} style={{border:'none'}} role="button"
                                onClick={(e) => this.props.ModifyTeens(-1)}>
                                <FontAwesomeIcon icon={faMinusSquare} /></button>
                        </Grid>
                        <Grid item xs={2} className="caption">
                            <div title={t('pax.teens.selected', { count: this.props?.filters.rooms[0]?.teens.length })} role="spinbutton" aria-live="polite"  aria-label={t('pax.teens.selected', { count: this.props?.filters.rooms[0]?.teens.length })}>
                                <strong>{this.props?.filters.rooms[0]?.teens.length}</strong></div></Grid>
                        <Grid item xs={5} >
                            <button className="plus"  aria-label={t('pax.teens.add')} title={t('pax.teens.add')} style={{border:'none'}} role="button"
                                onClick={(e) => this.props.ModifyTeens(1)}>
                            <FontAwesomeIcon icon={faPlusSquare} /></button>
                        </Grid>
                    </Grid>
                </Grid>
                </label>

                <label tabIndex={0} style={{width:'100%',display:'flex'}}>
                <Grid item xs={6} className="title mb-3 mt-3">
                    <h4>{t('pax.children.title')} </h4>
                    <small>{t('pax.children.ageRange')}</small>
                </Grid>
                <Grid item xs={6} className="mb-3 mt-3" align="center"  role="group" aria-label={t('pax.ariaLabels.children')}>
                    <Grid container style={{alignItems:'center', direction: 'ltr'}}>
                        <Grid item xs={5}>
                            <button className="minus" name="children"  title={t('pax.children.remove')} aria-label={t('pax.children.remove')} style={{border:'none'}}  role="button"
                                onClick={(e) => this.props.ModifyChildren(-1)}>
                                <FontAwesomeIcon icon={faMinusSquare} /></button>
                        </Grid>
                        <Grid item xs={2} className="caption">
                        <div title={t('pax.children.selected', { count: this.props?.filters.rooms[0]?.children.length })} role="spinbutton" aria-live="polite"  aria-label={t('pax.children.selected', { count: this.props?.filters.rooms[0]?.children.length })}>
                            <strong>{this.props?.filters.rooms[0]?.children.length}</strong></div>
                        </Grid>
                        <Grid item xs={5}>
                            <button className="plus" name="children"   title={t('pax.children.add')} aria-label={t('pax.children.add')} style={{border:'none'}} role="button"
                                onClick={(e) => this.props.ModifyChildren(1)}>
                                <FontAwesomeIcon icon={faPlusSquare} /></button>
                        </Grid>
                    </Grid>
                </Grid>
                </label>

                <label tabIndex={0} style={{width:'100%',display:'flex'}}>
                <Grid item xs={6} className="title mb-3 mt-3">
                    <h4>{t('pax.infants.title')}</h4>
                    <small>{t('pax.infants.ageRange')}</small>
                </Grid>
                <Grid item xs={6} className="mb-3 mt-3" align="center"   role="group" aria-label={t('pax.ariaLabels.infants')}>
                    <Grid container style={{alignItems:'center', direction: 'ltr'}}>
                        <Grid item xs={5}>
                            <button className="minus" name="infants"  title={t('pax.infants.remove')} aria-label={t('pax.infants.remove')} style={{border:'none'}} role="button"
                                onClick={(e) => this.props.ModifyInfants(-1)}>
                                <FontAwesomeIcon icon={faMinusSquare} /></button>
                        </Grid>
                        <Grid item xs={2} className="caption">
                        <div title={t('pax.infants.selected', { count: this.props?.filters.rooms[0]?.infants.length })} role="spinbutton" aria-live="polite"  aria-label={t('pax.infants.selected', { count: this.props?.filters.rooms[0]?.infants.length })}>
                            <strong>{this.props?.filters.rooms[0]?.infants.length}</strong></div>
                        </Grid>
                        <Grid item xs={5}>
                            <button className="plus" name="infants"   title={t('pax.infants.add')} aria-label={t('pax.infants.add')} style={{border:'none'}}  role="button"
                                onClick={(e) => this.props.ModifyInfants(1)}>
                                <FontAwesomeIcon icon={faPlusSquare} /></button>
                        </Grid>
                    </Grid>
                </Grid>
                </label>
            </div>
        )   
    } 
}

export default withTranslation()(Room)